<div class="layout-column m-r-10">
  @if (required) {
    <mat-form-field class="flex-100">
      <mat-label>{{ 'labels.inputs.' + inputLabel | translate }}</mat-label>
      <mat-select required [formControl]="inputFormControl">
        <mat-option>
          <ngx-mat-select-search
            placeholderLabel="{{ placeHolderLabel }}"
            noEntriesFoundLabel="{{ noEntriesFoundLabel }}"
            [formControl]="filterFormCtrl"
          ></ngx-mat-select-search>
        </mat-option>
        @for (glAccount of glAccountData | async; track glAccount) {
          <mat-option [value]="glAccount.id">
            {{ '(' + glAccount.glCode + ') ' + glAccount.name }}
          </mat-option>
        }
      </mat-select>
      @if (inputFormControl.hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Account' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>
  }

  @if (!required) {
    <mat-form-field class="flex-100">
      <mat-label>{{ 'labels.inputs.' + inputLabel | translate }}</mat-label>
      <mat-select [formControl]="inputFormControl">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="filterFormCtrl"
            placeholderLabel="{{ placeHolderLabel }}"
            noEntriesFoundLabel="{{ noEntriesFoundLabel }}"
          >
          </ngx-mat-select-search>
        </mat-option>
        @for (glAccount of glAccountData | async; track glAccount) {
          <mat-option [value]="glAccount.id">
            {{ '(' + glAccount.glCode + ') ' + glAccount.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
